<template>
  <VaCard>
    <VaCardTitle class="pb-0!">
      <h1 class="card-title text-secondary font-bold uppercase">Faturamento Anual</h1>
    </VaCardTitle>
    <VaCardContent class="flex flex-row gap-1">
      <section class="w-1/2">
        <div class="text-xl font-bold mb-2">
          {{ formatMoney(homeStore.data.total_billing_year + homeStore.data.total_comission_year) }}
        </div>
        <p
          v-if="homeStore.data.total_billing_last_year > 0"
          class="text-xs whitespace-nowrap"
          :class="{
            'text-success': percentage > 0,
            'text-danger': percentage < 0,
          }"
        >
          <VaIcon v-if="percentage > 0" name="north_east" />
          <VaIcon v-if="percentage < 0" name="south_west" />
          {{ percentage.toFixed(2) }}%
          <span class="text-secondary">último ano</span>
        </p>
        <p v-else class="text-xs text-success whitespace-nowrap">
          <VaIcon name="north_east" />
          +99999%
          <span class="text-secondary">último ano</span>
        </p>
        <div class="my-4 gap-2 flex flex-col">
          <div class="flex items-center">
            <span class="inline-block w-2 h-2 mr-2" :style="{ backgroundColor: 'rgb(245, 74, 0)' }"></span>
            <span class="text-secondary">Vendas</span>
          </div>
          <div class="flex items-center">
            <span class="inline-block w-2 h-2 mr-2" :style="{ backgroundColor: '#ECF0F1' }"></span>
            <span class="text-secondary">Comissão</span>
          </div>
        </div>
      </section>
      <div class="w-1/2 flex items-center h-full flex-1 lg:pl-16 pl-2 -mr-1">
        <VaChart :data="chartData" class="chart chart--donut h-[90px] w-[90px]" type="doughnut" :options="options" />
      </div>
    </VaCardContent>
  </VaCard>
</template>

<script setup lang="ts">
import { VaCard, VaCardContent, VaCardTitle, VaIcon } from 'vuestic-ui'
// import { useChartData } from '@/data/charts/composables/useChartData'
import { doughnutConfig } from '../../../../components/va-charts/vaChartConfigs'
import { ChartOptions } from 'chart.js'
import { externalTooltipHandler } from '../../../../components/va-charts/external-tooltip'
import { useHomeStore } from '../../../../stores/home'
import { formatMoney } from '../../../../services/utils'
import { computed } from 'vue'
import VaChart from '../../../../components/va-charts/VaChart.vue'

const homeStore: any = useHomeStore()

const chartData = computed(() => ({
  labels: ['Vendas', 'Comissão'],
  datasets: [
    {
      backgroundColor: ['rgb(245, 74, 0)', '#ECF0F1'],
      data: [homeStore.data.total_billing_year ?? 0, homeStore.data.total_comission_year ?? 0],
    },
  ],
}))

const options: ChartOptions<'doughnut'> = {
  ...doughnutConfig,
  plugins: {
    ...doughnutConfig.plugins,
    tooltip: {
      enabled: false,
      position: 'nearest',
      external: externalTooltipHandler,
    },
  },
}

const percentage = computed(() => {
  if (homeStore.data.total_billing_last_year > homeStore.data.total_billing_year) {
    const percentage = (homeStore.data.total_billing_year / homeStore.data.total_billing_last_year) * 100
    return percentage - 100
  }

  return (homeStore.data.total_billing_last_year / homeStore.data.total_billing_year) * 100
})
</script>
